import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { pathOr } from 'ramda'
import { chatbotEvents } from '../state'
import { portfolioApiEvents } from 'modules/api/portfolio'

export interface TenantDetailsState {
  selectedParty: string | null
}

export const initialState: TenantDetailsState = {
  selectedParty: null,
}

const tenantDetailsSlice = createSlice({
  name: 'chatbot/dialogs/tenantDetails',
  initialState,
  reducers: {
    partySelected: (state, action: PayloadAction<{ id: string }>) => {
      state.selectedParty = action.payload.id
    },
    partySaved: (state, action: PayloadAction<{ id: string }>) => {
      state.selectedParty = action.payload.id
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        state.selectedParty = pathOr(null, ['parties', 'tenants', 'primary', 'partyId'], action.payload)
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, state => {
        state.selectedParty = null
      })
      .addCase(portfolioApiEvents.updateTenantParties_success, (state, action) => {
        state.selectedParty = action.payload.parties?.tenants?.primary?.partyId ?? null
      })
      .addCase(portfolioApiEvents.acceptApplication_success, (state, action) => {
        state.selectedParty = action.payload.parties?.tenants?.primary?.partyId ?? null
      })
  },
})

export const { reducer } = tenantDetailsSlice
export const tenantDetailsEvents = tenantDetailsSlice.actions
